<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      
      <!-- Table -->
        <!-- <div class="datatable-outer-container">
            <div class="datatable-main">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>Sr. No.</th>
                      <th>Particulars</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tr class="record-row">
                    <td class="row-item">
                      <strong>i</strong>
                    </td>
                    <td class="row-item">
                      <strong>Interest From Saving Accounts</strong>
                    </td>
                    <td class="row-item">
                      <input
                        type="text"
                        class="inputbox"
                        value=" ₹ "
                      >
                    </td>
                  </tr>
                  <tr class="record-row">
                    <td class="row-item">
                      <strong>ii</strong>
                    </td>
                    <td class="row-item">
                      <strong>Interest From Fixed Deposits</strong>
                    </td>
                    <td class="row-item">
                      <input
                        type="text"
                        class="inputbox"
                        value=" ₹ "
                      >
                    </td>
                  </tr>
                  <tr class="record-row">
                    <td class="row-item">
                      <strong>iii</strong>
                    </td>
                    <td class="row-item">
                      <strong>Any other income</strong>
                    </td>
                    <td class="row-item">
                      <input
                        type="text"
                        class="inputbox"
                        value=" ₹ "
                      >
                    </td>
                  </tr>
                </table>
              </div>
        </div> -->
        <!-- End -->

            
<template >
            <data-table
              :columns="otherIncTableColumns"
              :tableData="otherIncomeList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p v-if="slotprops.value.column.key == 'slno'">{{slotprops.value.index+1}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'particulars'"
                  >{{slotprops.value.record['name']}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :disable="false"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].planned"
                    />
                  </p>
                 
                </div>
              </template>
            </data-table>
          </template>
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="goBack"/>
              <btn :text="saveAsDraft ? 'Save as Draft' : 'Save'" type="primary" @click="submitData" v-if="itEnableValue"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "otherIncome",
  props: {
    IncomeOtherSource:{
      type:Object
    },
    saveAsDraft: {
      type: Boolean
    },
    itEnableValue:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      otherIncomeList: [
      {
          name: "Interest From saving Accounts",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Interest From Fixed Deposits",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Any other Income",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        }
      ],
            otherIncTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Planned",
          key: "planned"
        },
      ],

    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
    this.load();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    load(){
      if (this.IncomeOtherSource.length) {
            this.otherIncomeList = this.IncomeOtherSource;
          }
      //console.log("inside previous data",this.otherIncomeList);
    },
    async submitData(){
      this.$emit("incomeFromOtherSource",this.otherIncomeList)
       //  this.previousEmpData.salary_income.amount=this.salaryAmount;
    },

    // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back');
    }
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }


.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 54px;
            border-bottom: none;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #fff;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

.inputbox{
   width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}
</style>
